import About from '../components/about/About'
import Card from '../components/card/Card'
import Parallax from '../components/parallax/parallax'
import Swiper from '../components/slider/Swiper'
import Wpp from '../components/wpp/Wpp'
import type { Route } from './+types'

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Piscinas Naturais e Passeios de Buggy em Maragogi - BarraTour" },
    { name: "description", content: "Piscinas Naturais e Passeios de Buggy em Maragogi" },
  ];
}

export default function index() {
  return (
    <>
      <Swiper></Swiper>
      <div className="flex flex-wrap justify-center my-10">
        <Card title="Piscinas Naturais" image="/home/03.webp" href="/piscinas-naturais">
            Tenha uma experiência inesquecível nas Piscinas Naturais de Maragogi
        </Card>
        <Card title="Buggy em Maragogi" image="/home/11.jpeg" href="/buggy-maragogi-norte">
            Conheça as mais belas Praias de Maragogi em um passeio maravilho
        </Card>
        <Card title="Buggy em São Miguel dos Milagres" image="/sao-miguel/03.jpeg" href="/buggy-sao-miguel">
            Passeio inesquecível nas melhores Praias do Litoral Norte de Alagoas
        </Card>
      </div>
      <Parallax></Parallax>
      <About></About>
      <Wpp></Wpp>
    </>
  )
}
